import type {
  BOPOrderSummariesResponse,
  BOPOrderSummaryResponse,
} from '../types/bopApi.types';
import type {
  OrderSummariesResponse,
  OrderSummary,
} from '../types/OrderHistory.types';

export const mapOrderSummariesResponse = (
  bopResponse: BOPOrderSummariesResponse
): OrderSummariesResponse => {
  return {
    offset: bopResponse.offset,
    count: bopResponse.count,
    total: bopResponse.total,
    orders: bopResponse.orders.map(mapOrderSummaryResponse),
  };
};

const mapOrderSummaryResponse = (
  bopOrder: BOPOrderSummaryResponse
): OrderSummary => {
  const { fractionDigits } = bopOrder.orderPriceSummary;

  return {
    ...bopOrder,
    orderPriceSummary: {
      ...bopOrder.orderPriceSummary,
      fractionDigits: fractionDigits ?? 2,
    },
  };
};
